exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.shift-hours-list-management-page[data-v-eba12d12] {\n  width: 100%;\n  height: 100%;\n}\n.header[data-v-eba12d12] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  margin-top: 1em;\n}\n.btn[data-v-eba12d12] {\n  background-color: #3b8686;\n}\n", ""]);

// exports
